import React, { useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { PremiumPlanDetails } from "./PremiumPlanDetails";

export const PremiumPlans = ({ plans, onClick }) => {
  const [selectedPlanId, setSelectedPlanId] = useState(plans[3].id);
  const selectedPlan = plans.find((plan) => plan.id === selectedPlanId);

  return (
    <Container fluid className="mt-5">
      <Row>
        {plans.map((plan) => (
          <Col key={plan.id} sm="3">
            <Button
              onClick={() => setSelectedPlanId(plan.id)}
              className={`premium-plan-btn ${selectedPlanId === plan.id ? "selected" : ""}`}
            >
                {plan.label}
            </Button>
          </Col>
        ))}
      </Row>

      <PremiumPlanDetails plan={selectedPlan} onClick={onClick} /> 
      
    </Container>
  );
};


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumPlans.js